<div class="modal-header">
  <h4 class="modal-title-top20">Upload order</h4>
</div>
<div class="modal-body">
  <app-loader *ngIf="!isLoadingDone" [data]="'processingFile'"></app-loader>
  <section *ngIf="isLoadingDone">
    <!-- <section class="error-data" *ngIf="displayData?.errorProductsMap.length > 0"> -->
    <section class="error-data">
      <section class="upload-order-err" *ngIf="uploadOrderRes?.errorFileDownloadUrl">
        <!-- <p class="error-black">Error: The uploaded excel file has the following issues:</p>
        <section class="line-no-items" *ngFor="let errProd of displayData?.errorProductsMap">
          <p><span class="line-no">Line {{errProd?.key}}: </span>
            <span class="line-items">{{errProd?.value?.message}}</span>
          </p>
        </section> -->
        <p class="error-black">Please download error file to see the error and upload it
          again after correcting them</p>
        <section>
          <a class="text-link sanofi-download-icon" href="{{mediaUrl}}">
            <img src="/../../../assets/icons/{{baseSiteId}}/download.png" alt=""> Error File</a>
        </section>
      </section>
      <section *ngIf="displayData?.locationsMap.length === 0">
        <section class="excel-content">
          <p class="excelTxt">Please ensure your Excel file includes the following:</p>
          <ul class="dotted-list">
            <li>Customer</li>
            <li>Material</li>
            <li>Quantity</li>
          </ul>
        </section>
        <div class="ad-upload-order">
          <div class="drag-drop drag_drop_file" id="drag_drop_file_upload" appFileDragDrop
            (filesChangeEmiter)="onFileChanges($event)">
            <div class="drag_drop_file_inside">
              <p class="body-copy-bold">Drag and drop file here to upload</p>
              <span class="body-copy">-or-</span>
            </div>
            <div class="file-upload-content white-button">
              <label for="img1" class="text browse-ticket">Select a file</label>
              <input type="file" name="uploadfile" (change)="uploadFiles($event)" id="img1" style="display:none;" />
            </div>
          </div>
          <a class="text-link sanofi-download-icon" target="_blank" (click)="downloadXls()">
            <img src="/../../../assets/icons/{{baseSiteId}}/download.png" alt="">
            Download the order template</a>
        </div>
      </section>
    </section>
    <section class="valid-data" *ngFor="let locMap of displayData?.locationsMap">
      <section class="row loc-unit">
        <section class="location">
          <h6> <img src="../../assets/icons/{{baseSiteId}}/location.svg">
            <span>{{locMap?.value?.custName}} ({{locMap?.value?.custNumber}})</span>
          </h6>
        </section>
        <section class="unit">
          {{locMap?.value?.totalQuantity}} Units
        </section>
      </section>
      <hr />
      <section>
        <ul class="row sec-rep" *ngFor="let validProd of locMap?.value?.mergedValidProducts">
          <li>
            <div class="img-container">
              <img class="flu-poster" *ngIf="validProd?.value?.PRIMARY !== undefined"
                src="{{ validProd?.value?.PRIMARY?.url }}" alt="" />
              <img class="flu-poster" *ngIf="validProd?.value?.PRIMARY === undefined"
                [src]="'../../assets/icons/'+baseSiteId+'/sanofi_missing_product.jpg'" alt="" />
            </div>
            <div class="txt-container">
              <span class="prod-desc"> <span class="product-name" [innerHTML]="validProd?.value?.baseProductName">
                </span><span [innerHTML]="validProd?.value?.baseProductDescription"></span></span>
              <!-- <span>$ --</span> -->
            </div>
            <div class="txt-quantity">
              <span>{{validProd.quantity}}</span>
            </div>
          </li>
        </ul>
      </section>
    </section>
  </section>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-primary" [disabled]="blockOrder" *ngIf="displayData?.locationsMap.length > 0"
    (click)="addToCart()">Add
    to cart</button>
  <button type="button" class="btn btn-secondary" (click)="close()">Cancel</button>
</div>